import useTelaGrande from '../../../hooks/useTelaGrande';
import useAuth from 'hooks/useAuth';
import AccountPopover from './AccountPopover';
import NotificacoesPopover from './NotificacoesPopover';
import BotaoTema from './BotaoTema';

/* ============================================================================
   Faixa superior do dashboard - visual novo (shadcn + Tailwind).

   Substitui AppBar/Toolbar do MUI com `cssStyles().bgBlur()` e
   `backgroundColor: primary.darker`.

   TRES DECISOES:

   1. A FAIXA USA A COR DA PALETA (`bg-primary`), acompanhando o que estiver
      escolhido em Aparencia.

      ⚠️ ISTO REVERTE uma decisao que eu havia tomado e defendido aqui: eu tinha
      deixado a faixa neutra argumentando que a cor mais forte deveria ficar
      reservada para significar estado. O usuario pediu a cor da paleta duas vezes,
      a segunda deixando claro o critério - "depende da cor selecionada". Fica
      registrado que foi decisao dele, e nao que o argumento anterior se aplicava e
      foi esquecido: quem for mexer aqui sabe que a troca foi pedida.

      O QUE A COR EXIGIU EM VOLTA: tudo que fica dentro da faixa passou a herdar a
      cor do texto (`text-primary-foreground`) em vez de usar `text-muted-foreground`
      e `border-line`. Sem isso os icones e o nome do usuario continuavam em cinza
      escuro sobre fundo escuro - foi exatamente o que aconteceu no cabecalho das
      tabelas na primeira tentativa.

   2. A MARCA SAIU DAQUI e foi para o topo da sidebar (ver NavbarVertical). No
      mobile, onde nao ha sidebar visivel, ela volta ao lado do botao de menu -
      senao a tela fica sem identificacao nenhuma.

   3. O nome do usuario deixou de ser um `<span>` solto entre dois botoes e
      virou o rotulo do proprio botao da conta, onde o clique ja levava. Antes o
      nome estava ao lado, fora da area clicavel: quem tentava clicar no nome nao
      abria nada.

   O deslocamento lateral vem de `--gps-lateral`, definido pelo shell
   (layouts/dashboard/index.jsx). Assim a faixa e o conteudo acompanham a sidebar
   recolhendo com UMA variavel, em vez de repetir a conta em dois lugares.
   ============================================================================ */

export default function DashboardHeader({ onOpenSidebar, isCollapse = false, verticalLayout = false }) {
  const isDesktop = useTelaGrande();
  const { user } = useAuth();

  return (
    <header
      className="fixed right-0 top-0 z-[1100] flex items-center gap-2 border-b border-primary bg-primary px-3 text-primary-foreground"
      style={{
        height: 'var(--gps-topbar-h)',
        // No layout horizontal a sidebar nao existe: a faixa ocupa a largura toda.
        left: verticalLayout ? 0 : 'var(--gps-lateral, 0px)',
      }}
    >
      {!isDesktop && (
        <>
          <button
            type="button"
            onClick={onOpenSidebar}
            aria-label="Abrir menu"
            className="grid h-8 w-8 place-items-center rounded-md border border-primary-foreground/40 text-[14px] text-primary-foreground"
          >
            ☰
          </button>
          {/* Mesma correcao da lateral: a marca e a IMAGEM (745x287, com o nome
              desenhado dentro). `w-7` a espremia num quadrado e o nome ficava
              ilegivel; e o texto ao lado repetia o que a imagem ja diz. */}
          {/* Versao BRANCA da marca: no mobile ela aparece dentro da faixa, que e da
              cor primary. Com o arquivo colorido o "hub" (texto escuro) desaparecia. */}
          <img src="/images/gps_hub2.png" alt="GPShub" className="h-7 w-auto object-contain" />
        </>
      )}

      <div className="flex-1" />

      {/* CLARO/ESCURO NA FAIXA (10/09/2026, no lugar da engrenagem).

          O painel de aparencia oferecia quatro ajustes; tres deles tinham
          resposta unica e certa - largura sempre total, cor sempre a do
          sistema, e o layout nunca mudava - e ficavam ali so cobrando uma
          decisao de quem entrou para trabalhar. O quarto, claro/escuro, e
          escolha legitima e pessoal: virou um botao, no lugar onde a pessoa
          ja olha. */}
      <BotaoTema />
      <NotificacoesPopover />
      <AccountPopover nome={user?.nome} />
    </header>
  );
}
